export default __webpack_public_path__ + "static/media/poi_ambulance_multi.1bc9aef4.svg";